/* src/sb-modules/Frontend-User-Avatar-Module/user-avatar.component.scss */
:host {
  display: block;
}
:host .avatar-with-label {
  margin: 0 12px 0 6px;
}
:host .user-native-avatar {
  height: 40px;
  min-height: 40px;
  min-width: 40px;
  width: 40px;
}
:host .user-native-avatar.user-avatar-xlg {
  height: 120px;
  min-height: 120px;
  min-width: 120px;
  width: 120px;
}
:host .user-native-avatar.user-avatar-lg {
  height: 80px;
  min-height: 80px;
  min-width: 80px;
  width: 80px;
}
:host .user-native-avatar.user-avatar-sm {
  height: 34px;
  min-height: 34px;
  min-width: 34px;
  width: 34px;
}
:host .user-native-avatar.user-avatar-btn {
  height: 24px;
  min-height: 24px;
  min-width: 24px;
  width: 24px;
}
:host .user-native-avatar.user-avatar-xs {
  height: 26px;
  min-height: 26px;
  min-width: 26px;
  width: 26px;
}
:host .user-native-avatar.user-avatar-xxs {
  height: 20px;
  min-height: 20px;
  min-width: 20px;
  width: 20px;
}
:host .staff-ring {
  height: 100%;
  position: relative;
  width: 100%;
}
:host .staff-ring::after {
  border-right: 3px solid #fed030;
  border-left: 3px solid black;
  border-radius: 50%;
  border-top: 3px solid black;
  border-bottom: 3px solid #fed030;
  content: "";
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  transform: rotateY(0deg) rotate(45deg);
  width: 100%;
  height: 100%;
}
:host .avatar-label {
  position: absolute;
  height: auto;
  left: 50%;
  transform: translateX(-50%);
  min-height: 14px;
  text-align: center;
  line-height: 14px;
  padding: 0 3px;
  background-color: #fed030;
  color: #000;
  font-size: 10px;
  margin-top: 2px;
  border-radius: 3px;
}
/*# sourceMappingURL=user-avatar.component.css.map */
